/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModals, resetModals } from './use-modals'
import { show, safeURL, openWindow, viewBack } from '../twd/twd'

export default ({from}) => {

    return <React.Fragment>
    <div
        data-name="order-ticket-duplicate-order-modal"
        className="modal-dialog modal-sm">
    <div className="modal-content" >
    <div className="modal-header">
        <button
            className="close"
            aria-label="close"
            data-name="order-ticket-duplicate-order-modal-close-button"
            type="button"
            onClick={() => {
                hideModals()
            }}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>

        <h2 className="modal-title text-center vertical-offset-sm">Duplicate Order Notice</h2>

        <div className="row">
        <div className="col-xs-12 col-md-12 text-body">
            <p>You have an existing open (or recently executed) order for this CUSIP on the same side of the market.</p>
            <p>If you did not intend to place a second order for this CUSIP, please select “Cancel order” to return to modify your order now. Otherwise, select “Acknowledge duplicate” to proceed with this trade.</p>
        </div>
        </div>

    </div>


    <div className='modal-footer'>
    <div className="container" style={{background:"#ffffff" }}>

    <div className="row vertical-offset-sm">
    <div className="col-md-12 text-center">
        <button
            className="btn btn-block btn-primary"
            aria-label="acknowledge duplicate"
            data-name="order-ticket-duplicate-order-modal-acknowledge-button"
            type="button"
            onClick={() => {
                hideModals()
            }}>
            Acknowledge duplicate
        </button>
    </div>
    </div>

    <div className="row">
    <div className="col-md-12 text-center">
        <button
            className="btn btn-primary-outline"
            aria-label="cancel order"
            data-name="order-ticket-duplicate-order-modal-cancel-button"
            type="button"
            onClick={() => {
                resetModals()

                if (!from) {
                    show('overview')
                    return
                }

                let u = safeURL(from)
                if (u) {
                    openWindow(u.toString())
                    return
                }

                viewBack()
            }}>
            Cancel order
        </button>
    </div>
    </div>

    </div>
    </div>
    </div>
    </div>

    </React.Fragment>
}
